/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, Link, TextStyle } from '@shopify/polaris';
import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { RenderRadioButtonItem } from 'src/components/views/common/forms/render-radio-button-item';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { RenderTooltip } from 'src/components/views/common/render-tooltip';
import { AJAX_CART_DISPLAY_TYPES_V2, MENU_ID } from 'src/constants/theme-settings.jsx';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class AjaxCartForm extends Component<ComposedProps> {
  state = {};

  /**
   * Get AJAX cart display types
   * @returns
   */
  getDisplayTypes = () => {
    const { i18n } = this.props;

    return AJAX_CART_DISPLAY_TYPES_V2.map((option, index) => {
      const { label, value, tooltipImage, tooltipText } = option;
      return (
        <div key={index} style={{ display: 'flex', gap: '6px' }}>
          <Field
            name={`setting.${MENU_ID.AJAX_CART}.cartStyle`}
            id={value}
            component={RenderRadioButtonItem}
            label={i18n.translate(label)}
          />
          {tooltipImage && (
            <RenderTooltip content={<img src={tooltipImage} alt="" />} icon={true} />
          )}
          {tooltipText && <RenderTooltip content={i18n.translate(tooltipText)} icon={true} />}
        </div>
      );
    });
  };

  render() {
    const { i18n, formValues } = this.props;

    const ajaxCartEnabled = _.get(formValues, `setting.${MENU_ID.AJAX_CART}.enableCart`);

    return (
      <FormLayout>
        <div>
          <div className="form-section">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.ajaxCart_HelpText_Label', {
                t1: (
                  <Link external url={URL['AjaxCartThemeSetting']}>
                    {i18n.translate('AdminHTML.ThemeSetting.Form.quickView_HelpText_t1')}
                  </Link>
                )
              })}
            </TextStyle>

            <div className="form-section__item form-section__item--standard-spacing">
              <Field
                name={`setting.${MENU_ID.AJAX_CART}.enableCart`}
                component={RenderToggleSwitch}
                label={i18n.translate('AdminHTML.ThemeSetting.Form.ajaxCart_Toggle_Label')}
              />
            </div>

            {ajaxCartEnabled && (
              <div
                className="form-section__item form-section__item--standard-spacing"
                style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <p>{i18n.translate('AdminHTML.ThemeSetting.Form.ajaxCart_DisplayType_Label')}</p>
                {this.getDisplayTypes()}
              </div>
            )}
          </div>
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(AjaxCartForm);
